import { useState } from 'react';
import { faqs } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" aria-labelledby="faq-title" className="scroll-mt-28 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.25em] text-primary-600">FAQ</p>
            <h2
              id="faq-title"
              className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl"
            >
              常见问题
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              关于内容来源、更新频率与隐私处理,大家问得最多的几个问题都在这里。还有疑问,欢迎通过底部表单联系我们。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-chat-3-line text-base" aria-hidden="true" />
              还有问题?找编辑聊聊
            </a>
          </div>

          <div className="lg:col-span-8">
            <ul className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <li key={item.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
                      >
                        <span className="flex items-start gap-3">
                          <span
                            className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs ${
                              isOpen
                                ? 'bg-primary-500 text-background-50'
                                : 'bg-background-200 text-foreground-600'
                            }`}
                          >
                            {index + 1}
                          </span>
                          <span className="font-heading text-base font-bold text-foreground-950">
                            {item.q}
                          </span>
                        </span>
                        <i
                          className={`shrink-0 text-xl text-foreground-500 transition-transform ${
                            isOpen ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                          }`}
                          aria-hidden="true"
                        />
                      </button>
                    </h3>
                    {isOpen && (
                      <p className="pb-6 pl-9 pr-8 text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}